module.exports = __webpack_public_path__ + "img/me.1009e4ac.jpg";